import moment from 'moment';
import SelectField from '../../../../common/formComponents/SelectField/SelectField';
import TextAreaField from '../../../../common/formComponents/TextAreaField/TextAreaField';
import TextField from '../../../../common/formComponents/TextField/TextField';
import YearPickerField from '../../../../common/formComponents/YearPickerField/YearPickerField';
import { getInputOptions } from '../../utils/getInputOptions';
import { houseInfoFieldsNames } from '../constants/houseInfoFieldsNames';
import { houseInfoRequiredMsg } from '../constants/houseInfoRequiredMsg';

const {
  name,
  type,
  constructionYear,
  commissioningYear,
  numberOfEntrances,
  numberOfFloors,
  numberOfRooms,
  numberOfLivingRooms,
  numberOfNonLivingRooms,
  totalArea,
  livingArea,
  nonLivingArea,
  numberOfElevators,
  numberOfFreightElevators,
  numberOfpassengerElevators,
  comment,
} = houseInfoFieldsNames;

export const getHouseInfoFieldsData = ({
  initialValues,
  form,
  areaInputProps,
}) => {
  const firstRowFields = [
    {
      label: 'Жилой комплекс',
      name,
      selectOptions: [
        { value: 'Копейка' },
        { value: 'Пятак' },
        { value: 'Четвертак' },
        { value: 'Полтинник' },
        { value: 'Рубль' },
      ],
      options: getInputOptions({
        // initialValue: initialValues && initialValues[name],
      }),
      span: 12,
      element: SelectField,
    },
    {
      label: 'Тип дома',
      name: type,
      options: getInputOptions({
        initialValue: initialValues &&
          initialValues[type] && {
            key: initialValues[type].id,
            label: initialValues[type].name,
          },
        requiredErrMsg: houseInfoRequiredMsg[type],
        fieldType: 'object',
      }),
      selectOptions: [
        { id: 1, name: 'МКД' },
        { id: 2, name: 'Одноквартирный дом' },
        { id: 3, name: 'Коттедж' },
      ],
      valueKey: 'id',
      contentKey: 'name',
      selectProps: {
        labelInValue: true,
        getPopupContainer: () => document.querySelector('.houseInfoModal'),
      },
      span: 12,
      element: SelectField,
    },
  ];

  const yearFields = [
    {
      label: 'Год постройки',
      name: constructionYear,
      options: getInputOptions({
        initialValue:
          initialValues?.buildingDate && moment(initialValues.buildingDate),
        requiredErrMsg: houseInfoRequiredMsg[constructionYear],
        fieldType: 'object',
      }),
      span: 12,
      element: YearPickerField,
    },
    {
      label: 'Год ввода в эксплуатацию',
      name: commissioningYear,
      options: getInputOptions({
        initialValue:
          initialValues?.commissioningDate &&
          moment(initialValues.commissioningDate),
        requiredErrMsg: houseInfoRequiredMsg[commissioningYear],
        fieldType: 'object',
      }),
      span: 12,
      element: YearPickerField,
    },
  ];

  const numOfFields = [
    {
      label: 'Количество подъездов',
      name: numberOfEntrances,
      options: getInputOptions({
        initialValue:
          initialValues?.entranceCount && String(initialValues.entranceCount),
        requiredErrMsg: houseInfoRequiredMsg[numberOfEntrances],
        validationTypes: ['integer', 'zero'],
      }),
      span: 12,
      element: TextField,
    },
    {
      label: 'Количество этажей',
      name: numberOfFloors,
      options: getInputOptions({
        initialValue:
          initialValues?.floorCount && String(initialValues.floorCount),
        requiredErrMsg: houseInfoRequiredMsg[numberOfFloors],
        validationTypes: ['integer', 'zero'],
      }),
      span: 12,
      element: TextField,
    },
  ];

  const numOfRoomsFields = [
    {
      label: 'Всего помещений',
      name: numberOfRooms,
      options: getInputOptions({
        initialValue:
          initialValues?.premisesCount && String(initialValues.premisesCount),
        form,
        requiredErrMsg: houseInfoRequiredMsg[numberOfRooms],
        validationTypes: ['integer', 'zero', 'sum'],
        sumFieldsName: [numberOfLivingRooms, numberOfNonLivingRooms],
        sumErrMsg:
          'Число помещений не совпадает с суммой жилых и нежилых помещений',
      }),
      span: 8,
      element: TextField,
    },
    {
      label: 'Жилых помещений',
      name: numberOfLivingRooms,
      options: getInputOptions({
        initialValue:
          initialValues?.flatCount && String(initialValues.flatCount),
        form,
        forceValidateFieldsName: [numberOfRooms],
        requiredErrMsg: houseInfoRequiredMsg[numberOfLivingRooms],
        validationTypes: ['integer', 'force'],
      }),
      span: 8,
      element: TextField,
    },
    {
      label: 'Нежилых помещений',
      name: numberOfNonLivingRooms,
      options: getInputOptions({
        initialValue:
          initialValues?.officeCount && String(initialValues.officeCount),
        form,
        forceValidateFieldsName: [numberOfRooms],
        requiredErrMsg: houseInfoRequiredMsg[numberOfNonLivingRooms],
        validationTypes: ['integer', 'force'],
      }),
      span: 8,
      element: TextField,
    },
  ];

  const areaFields = [
    {
      label: 'Общая площадь дома',
      name: totalArea,
      options: getInputOptions({
        initialValue:
          initialValues?.totalArea && String(initialValues.totalArea),
        form,
        requiredErrMsg: houseInfoRequiredMsg[totalArea],
        validationTypes: ['zero', 'fractional', 'sum'],
        sumFieldsName: [livingArea, nonLivingArea],
        sumErrMsg:
          'Площадь дома не совпадает с суммой площадей жилых и нежилых помещений',
      }),
      span: 8,
      inputProps: {
        suffix: areaInputProps.suffix,
      },
      element: TextField,
    },
    {
      label: 'Площадь жилых пом.',
      name: livingArea,
      options: getInputOptions({
        initialValue: initialValues?.flatArea && String(initialValues.flatArea),
        form,
        forceValidateFieldsName: [totalArea],
        requiredErrMsg: houseInfoRequiredMsg[livingArea],
        validationTypes: ['force', 'fractional'],
      }),
      span: 8,
      inputProps: {
        ...areaInputProps,
        addonAfter: areaInputProps.addonAfter(livingArea),
      },
      element: TextField,
    },
    {
      label: 'Площадь нежилых пом.',
      name: nonLivingArea,
      options: getInputOptions({
        initialValue:
          initialValues?.officeArea && String(initialValues.officeArea),
        form,
        forceValidateFieldsName: [totalArea],
        requiredErrMsg: houseInfoRequiredMsg[nonLivingArea],
        validationTypes: ['force', 'fractional'],
      }),
      span: 8,
      inputProps: {
        ...areaInputProps,
        addonAfter: areaInputProps.addonAfter(nonLivingArea),
      },
      element: TextField,
    },
  ];

  const numOfElevatorsFields = [
    {
      label: 'Общее количество лифтов',
      name: numberOfElevators,
      options: getInputOptions({
        initialValue:
          initialValues?.elevatorCount && String(initialValues.elevatorCount),
        form,
        requiredErrMsg: houseInfoRequiredMsg[numberOfElevators],
        validationTypes: ['integer', 'sum'],
        sumFieldsName: [numberOfFreightElevators, numberOfpassengerElevators],
        sumErrMsg:
          'Число лифтов не совпадает с суммой грузовых и пассажирских лифтов',
      }),
      span: 8,
      element: TextField,
    },
    {
      label: 'Грузовых лифтов',
      name: numberOfFreightElevators,
      options: getInputOptions({
        initialValue:
          initialValues?.serviceElevatorCount &&
          String(initialValues.serviceElevatorCount),
        form,
        forceValidateFieldsName: [numberOfElevators],
        requiredErrMsg: houseInfoRequiredMsg[numberOfFreightElevators],
        validationTypes: ['integer', 'force'],
      }),
      span: 8,
      element: TextField,
    },
    {
      label: 'Пассажирских лифтов',
      name: numberOfpassengerElevators,
      options: getInputOptions({
        initialValue:
          initialValues?.passengerElevatorCount &&
          String(initialValues.passengerElevatorCount),
        form,
        forceValidateFieldsName: [numberOfElevators],
        requiredErrMsg: houseInfoRequiredMsg[numberOfpassengerElevators],
        validationTypes: ['integer', 'force'],
      }),
      span: 8,
      element: TextField,
    },
  ];

  // const commentFields = [
  //   {
  //     label: 'Комментарий',
  //     name: comment,
  //     options: getInputOptions({
  //       initialValue:
  //         initialValues && initialValues[numberOfpassengerElevators],
  //       form,
  //     }),
  //     span: 24,
  //     inputProps: { rows: 3, placeholder: 'Ваш комментарий' },
  //     element: TextAreaField,
  //   },
  // ];

  return {
    firstRowFields,
    yearFields,
    numOfFields,
    numOfRoomsFields,
    areaFields,
    numOfElevatorsFields,
    // commentFields,
  };
};
